const GENERAL_TRAINING_TYPES = [
  'generalBasis',
  'generalBasisWithoutPrivileges',
  'specialtiesByTheEconomy',
  'pedagogicalSpecialties',
  'gold',
];

function getGroupNameField(studyPay, typeTraining) {
  if (typeTraining === 'targetTraining') {
    return 'name_celev';
  }
  if (typeTraining === 'olympiad') {
    return studyPay === 'paid' ? 'name_olimp_plat' : 'name_olimp_budget';
  }
  if (GENERAL_TRAINING_TYPES.includes(typeTraining)) {
    return studyPay === 'paid' ? 'name_plat' : 'name_budget';
  }
  return studyPay === 'paid' ? 'name_plat' : 'name_budget';
}

export function getGroupDisplayName(groupData, studyPay, typeTraining) {
  if (!groupData) {
    return null;
  }

  const nameField = getGroupNameField(studyPay, typeTraining);
  const name = groupData[nameField];

  if (!name || !String(name).trim()) {
    return null;
  }

  return name;
}
